import Aegis from 'aegis-web-sdk'
let aegis = null
if (process.env.VUE_APP_LOGIN_ENV === 'prod') {
  // eslint-disable-next-line no-unused-vars
  aegis = new Aegis({
    id: '3DEar4MGlRDnBvn26K', // 应用ID，即上报key
    reportApiSpeed: true, // 接口测速
    reportAssetSpeed: true // 静态资源测速
  })
}

export default aegis
